import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { resolveSearchResultDestination } from './searchResultNavigation';

/**
 * Canonical CommandBar navigation handler for production dashboard routes.
 * Used by AppShell so palette reachability is not gated on per-route auth-loading branches.
 *
 * Search results carry `payload.resultType` + `payload.id`. That id-aware path
 * takes precedence over the backend's leading-slash list route, which is
 * treated as a fallback only.
 */
export function useCommandBarNavigate() {
  const navigate = useNavigate();

  return useCallback((destination, payload = {}) => {
    const resolved = resolveSearchResultDestination(destination, payload);
    if (resolved) {
      navigate(resolved);
      return;
    }

    if (!destination) return;
    if (destination.startsWith('/')) {
      navigate(destination);
    }
  }, [navigate]);
}

export default useCommandBarNavigate;
